import React from 'react'
import GetAPI from '../components/GetAPI'
import Header from '../components/Header'
const DevDotTo = () => {
    return (
        <div>
            <Header />
            <GetAPI />
        </div>
    )
}


export default DevDotTo
